import { render, staticRenderFns } from "./ResourcesTrainingIndex.vue?vue&type=template&id=b482d31c&"
import script from "./ResourcesTrainingIndex.vue?vue&type=script&lang=js&"
export * from "./ResourcesTrainingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports